import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { getWaitlistCount } from "@/lib/api";

/**
 * Live social-proof counter. Shows the real waitlist count with graceful
 * copy for very low numbers (no fabricated figures).
 */
export const SignupCounter = () => {
  const [count, setCount] = useState(null);

  useEffect(() => {
    let active = true;
    getWaitlistCount()
      .then((c) => active && setCount(c))
      .catch(() => active && setCount(null));
    return () => {
      active = false;
    };
  }, []);

  if (count === null) return null;

  return (
    <motion.div
      data-testid="signup-counter"
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className="mt-10 flex items-center gap-4 border-t border-espresso/10 pt-8"
    >
      <span className="font-display text-5xl font-light leading-none text-oak">
        {count === 0 ? "01" : String(count).padStart(2, "0")}
      </span>
      <span className="max-w-[16rem] font-body text-sm font-light text-stone">
        {count === 0
          ? "Be the very first to register your interest."
          : count === 1
          ? "person has already registered their interest."
          : "people have already registered their interest."}
      </span>
    </motion.div>
  );
};

export default SignupCounter;
